import { Link } from "react-router-dom";
import { useDocumentTitle } from "../lib/title";

export default function NotFound() {
  useDocumentTitle("صفحه پیدا نشد");
  return (
    <section className="section">
      <div className="wrap wrap--narrow" style={{ textAlign: "center" }}>
        <span className="eyebrow">404</span>
        <h1 className="sec-head__title" style={{ margin: "0 auto var(--s-5)" }}>
          این صفحه پیدا نشد
        </h1>
        <Link to="/" className="btn">بازگشت به خانه</Link>
      </div>
    </section>
  );
}
